import { getAccountApi } from '@/api/user';
import { loginOut } from '@/api/getData';
import newVue from '../../main';

const auth = {
  namespaced: true,
  state: {
    menusRouterCodeList: [],
  },
  getters: {},
  mutations: {
    setMenusRouterCodeList(state, arr) {
      state.menusRouterCodeList = arr;
    },
  },
  actions: {
    async setAccountInfo(context) {
      let yjkjAccountInfo = {};
      if (localStorage.getItem('yjkjAccountInfo')) {
        yjkjAccountInfo = JSON.parse(localStorage.getItem('yjkjAccountInfo'));
      } else {
        const res = await getAccountApi();
        if (res && res.status) {
          yjkjAccountInfo = res.data;
          localStorage.setItem('yjkjAccountInfo', JSON.stringify(yjkjAccountInfo));
        }
      }
      menusList = [];
      if (yjkjAccountInfo.menus === null || yjkjAccountInfo.menus === undefined) {
        loginOut().then(({ status }) => {
          if (status) {
            newVue.$router.push({ name: 'login' });
          }
        });
        return;
      }

      const list = flatMenusList(yjkjAccountInfo.menus);
      const codeArr = list.map(item => item.code);
      context.commit('setMenusRouterCodeList', codeArr);

      // 埋点初始化
      newVue.$QTumeng.init({
        enable: false,
        uid: yjkjAccountInfo.accountId,
      });

      newVue.$QTumeng.appendMetaInfo({ distributor_id: yjkjAccountInfo.accountId });
    },
  },
};

let menusList = [];
function flatMenusList(list) {
  list.forEach(item => {
    menusList.push(item);
    if (item.child) {
      flatMenusList(item.child);
    }
  });
  return menusList;
}

export default auth;



// WEBPACK FOOTER //
// ./src/store/modules/auth.js